import { useEffect, useState } from 'react';

/** Локальная ссылка для предпросмотра выбранного файла; освобождается при смене файла и размонтировании. */
export function useObjectUrl(file: File | null): string | null {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    if (!file) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- ссылка создаётся побочным эффектом (createObjectURL), поэтому и сброс — здесь
      setUrl(null);
      return undefined;
    }
    const objectUrl = URL.createObjectURL(file);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);
  return url;
}
